require(`./lbSearchResultsProgress.scss`);

const lbSearchResultsProgress = angular.module('app.lbSearchResultsProgress', []);

lbSearchResultsProgress.component('lbSearchResultsProgress', {
  bindings: {
    finalStep: '<'
  },
  controllerAs: 'vm',
  controller: ['locationService', 'itinerariesService', controller],
  template: require('./lbSearchResultsProgress.html')
});

function controller(locationService, itinerariesService) {
  let vm = this;

  vm.itinerariesService = itinerariesService;
  vm.locationService = locationService;
  vm.gotoSection = gotoSection;
  vm.cancelBooking = locationService.cancelBooking;

  function gotoSection(item) {
    if (!vm.finalStep) {
      vm.locationService.gotoSection(item)
    }
  }
}

export default lbSearchResultsProgress;


// WEBPACK FOOTER //
// ./src/components/lbSearchResultsProgress/lbSearchResultsProgress.js